module.exports = __webpack_public_path__ + "a19361b2971924b1584f2c8f57bfb177.svg";


//////////////////
// WEBPACK FOOTER
// ./images/step2-green.svg
// module id = 1130
// module chunks = 0